"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxType = void 0;
var TaxType;
(function (TaxType) {
    TaxType["AFTER_TAX"] = "AFTER_TAX";
    TaxType["ANNUITY"] = "ANNUITY";
    TaxType["EDUCATION"] = "EDUCATION";
    TaxType["INHERITED_TAX_DEFERRED"] = "INHERITED_TAX_DEFERRED";
    TaxType["TAXABLE"] = "TAXABLE";
    TaxType["TAXABLE_CASH"] = "TAXABLE_CASH";
    TaxType["TAX_DEFERRED"] = "TAX_DEFERRED";
    TaxType["TAX_FREE"] = "TAX_FREE";
    TaxType["UNKNOWN"] = "UNKNOWN";
})(TaxType = exports.TaxType || (exports.TaxType = {}));
